import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/cart.png'


const _withScopeId = n => (_pushScopeId("data-v-38b1ae00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-info" }
const _hoisted_2 = { class: "customer-product" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "item flex" }
const _hoisted_5 = { class: "item flex" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_7 = { class: "purchase-product" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "item flex" }
const _hoisted_10 = { class: "item flex" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_12 = { class: "item flex" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "log-list"
}
const _hoisted_15 = { class: "log-title" }
const _hoisted_16 = {
  key: 0,
  style: {"margin-left":"0"}
}
const _hoisted_17 = { key: 1 }

import { t } from '@/plugins/i18n'
import { getJapanTime } from '@/util/common'
import { countryCodeNameMap } from '@/common/const'
import { ref, reactive, onActivated, computed } from 'vue'
import AppLink from '@/components/common/AppLink.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import STable from '@/components/Table/index.vue'
import SPagination from '@/components/common/pagination/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { ordeProductDetails, orderRepurchase } from '@/apis/order'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { setProdcutLink } from '../data'
import LogoIcon from '@/components/common/LogoIcon.vue'
import { useRtfix } from '@/store'
import { BASE_IMAGE } from '@/common/baseImage'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
// 1 1688 2 oem
const productType = ref<any>(route.query.productType ?? '')
onActivated(() => {
  productType.value = route.query.productType
  pageData.pageNum = 1
  pageData.pageSize = 10
  getProductDetails()
})

const productDetails: any = reactive({
  customerProductInfo: null,
  productStatusChangeLog: [],
  purchaseProductInfo: null
})

const total = ref(0)
const pageData = reactive({
  pageNum: 1,
  pageSize: 30
})
const getImage = (val: string, abc?: string) => {
  return val?.split(',')?.[0] || BASE_IMAGE
}

const currentPage = computed({
  get() {
    return {
      page: pageData.pageNum,
      limit: pageData.pageSize
    }
  },
  set(v: any) {
    const { page, limit } = v
    pageData.pageNum = page
    pageData.pageSize = limit
    getProductDetails()
  }
})

const getProductDetails = () => {
  ordeProductDetails({
    platformOrderItemId: route.query.platformOrderItemId,
    productSku: route.query.productSku,
    shopProductSku: route.query.shopProductSku,
    pageNum: pageData.pageNum,
    pageSize: pageData.pageSize
  }).then((res: any) => {
    if (res.success) {
      const { customerProductInfo, productStatusChangeLog, purchaseProductInfo, searchSourcePriceId } = res.data
      productDetails.customerProductInfo = customerProductInfo
      productDetails.productStatusChangeLog = productStatusChangeLog
      productDetails.purchaseProductInfo = purchaseProductInfo
      total.value = productDetails.productStatusChangeLog.total
    }
  })
}

const setOrderRepurchase = () => {
  if (!productDetails.purchaseProductInfo?.productSku) return ElMessage.warning('请确认采购商品信息')
  orderRepurchase({
    platformOrderNo: productDetails.purchaseProductInfo.platformOrderNo,
    shopProductSkus: [productDetails.purchaseProductInfo.shopProductSku],
    repurchaseType: 1,
    searchSourceSupplierPriceId: productDetails.purchaseProductInfo?.searchSourcePriceId === '-' ? '' : productDetails.purchaseProductInfo?.searchSourcePriceId
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('加购成功'))
    }
  })
}
const columns: any = [
  {
    label: t('商品状态'),
    prop: 'operateName',
    slotName: 'operateName'
  },
  {
    label: t('操作记录'),
    prop: 'operateDesc',
    align: 'center',
    slotName: 'operateDesc'
  },
  {
    label: t('变更时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  }
]
const jump = (row: any) => {
  if (row.orderItemLogType !== 12) {
    return
  }
  const routerUrl: any = router.resolve(useRtfix('AbnormalOrder', {
    query: {
      abnormal: 'ApplyCancel',
      platformOrderNo2: productDetails.purchaseProductInfo.platformOrderNo,
      productSku: route.query.combineSku || productDetails.purchaseProductInfo.productSku,
      processManner: '0'
    }
  }))
  window.open(routerUrl.href, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('客户商品信息')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('客户商品SKU')) + "：" + _toDisplayString(_unref(productDetails).customerProductInfo?.apiShopProductSku), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('客户商品名称')) + "：" + _toDisplayString(_unref(productDetails).customerProductInfo?.apiShopProductTitle), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('客户商品规格')) + "：" + _toDisplayString(_unref(productDetails).customerProductInfo?.apiShopProductPropertiesName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('客户商品图片')) + "：", 1),
        (_unref(productDetails).customerProductInfo?.apiShopProductMainImg)
          ? (_openBlock(), _createBlock(ShoppingPreview, {
              key: 0,
              image: getImage(_unref(productDetails).customerProductInfo?.apiShopProductMainImg || '')
            }, null, 8, ["image"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_6
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('采购商品信息')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('平台商品SKU')) + "：" + _toDisplayString(_unref(productDetails).purchaseProductInfo?.productSku), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(t)('采购商品名称')) + "： ", 1),
          (_unref(productDetails).purchaseProductInfo?.platformType !== '-' && _unref(setProdcutLink)(_unref(productDetails)?.purchaseProductInfo))
            ? (_openBlock(), _createBlock(AppLink, {
                key: 0,
                to: _unref(setProdcutLink)(_unref(productDetails).purchaseProductInfo),
                target: '_blank'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(productDetails).purchaseProductInfo?.productTitleJp), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(productDetails).purchaseProductInfo?.productTitleJp), 1)
              ], 64))
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(t)('采购商品规格')) + ": ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(productDetails).purchaseProductInfo?.productPropertiesName || '').split(';'), (prop) => {
            return (_openBlock(), _createElementBlock("span", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, ' ')), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('采购商品图片')) + "：", 1),
        (_unref(productDetails).purchaseProductInfo?.productSkuImg || _unref(productDetails).purchaseProductInfo?.productMainImg)
          ? (_openBlock(), _createBlock(ShoppingPreview, {
              key: 0,
              image: getImage(_unref(productDetails).purchaseProductInfo?.productSkuImg || _unref(productDetails).purchaseProductInfo?.productMainImg)
            }, null, 8, ["image"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_11
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_unref(productDetails).purchaseProductInfo?.platformType)
          ? (_openBlock(), _createBlock(LogoIcon, {
              key: 0,
              class: "mr_5",
              type: _unref(productDetails).purchaseProductInfo?.platformType,
              url: _unref(productDetails).purchaseProductInfo?.productDetailUrl,
              underline: _unref(productDetails).purchaseProductInfo?.channel === 5,
              country: _unref(productDetails).customerProductInfo.goodsCountry
            }, null, 8, ["type", "url", "underline", "country"]))
          : _createCommentVNode("", true),
        (_unref(productDetails).customerProductInfo?.goodsCountry === _unref(COUNTRY).KR)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(AppLink, {
                to: _unref(setProdcutLink)(_unref(productDetails).purchaseProductInfo),
                target: '_blank'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(productDetails).customerProductInfo?.brandName ?? '-'), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_unref(productDetails).purchaseProductInfo?.platformType !== '-' && _unref(productDetails).purchaseProductInfo?.productType !== 2)
            ? (_openBlock(), _createBlock(AppLink, {
                key: 2,
                to: _unref(setProdcutLink)(_unref(productDetails).purchaseProductInfo),
                target: '_blank'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('商品采购渠道')), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
        (_ctx.$route.query.platformOrderItemId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (!(['1', '2'].includes(productType.value) && _unref(route).query.isGroup))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    referrerPolicy: "no-referrer",
                    src: _imports_0,
                    onClick: setOrderRepurchase
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (productType.value !== '3')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('商品状态变更日志')), 1),
          _createVNode(STable, {
            "table-data": _unref(productDetails).productStatusChangeLog.records,
            columns: columns,
            "show-pagination": false,
            onRowClick: jump
          }, {
            createTime: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(t)('时间')) + ": " + _toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
            ]),
            operateName: _withCtx(({ row }) => [
              (row.orderItemLogType === 12)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)(row.operateName)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(t)(row.operateName)), 1))
            ]),
            operateDesc: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(row.operateDesc), 1)
            ]),
            _: 1
          }, 8, ["table-data"]),
          _createVNode(SPagination, {
            style: {"margin-top":"6px"},
            "page-data": _unref(currentPage),
            "onUpdate:page-data": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
            "onUpdate:pageData": getProductDetails,
            total: total.value
          }, null, 8, ["page-data", "total"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})